import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterWriteFileListComponent } from './letter-write-file-list.component';
import { LetterWriteFileListFileRowModule } from './file-row/file-row.module';

@NgModule({
  declarations: [
    LetterWriteFileListComponent, 
  ],
  imports: [
    CommonModule,
    LetterWriteFileListFileRowModule,
  ],
  exports:[
    LetterWriteFileListComponent,
  ]
})
export class LetterWriteFileListModule { }
